export type SinglePayment = {
	requestId: string;
	requestType: 'GROUP_TOP_UP' | 'TOP_UP';
	date: string;
	amount: number;
	itemsCount: number;
	accountId?: string;
	phoneNumber?: string;
	username?: string;
	billingId?: string;
};

const model: types.models.InputModel = {
	requestId: 'paymentRequestId',
	requestType: 'paymentRequestType',
	date: 'paymentDate',
	amount: 'amount',
	itemsCount: 'itemsCount',
	accountId: 'accountId',
	phoneNumber: 'phoneNumber',
	username: 'username',
};

export default model;
